import * as React from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import { connect } from "react-redux";
import { centered_flex_box } from "../../app/components/Styles";
import { useNavigate, useParams } from "react-router-dom";
import { rejectInvitation } from "../../app/store/actions/commonActions";
import { MarketingPage, MarketingCard, MarketingButton } from "../../app/components/marketing";
import {
  marketingColors,
  marketingFonts,
  sectionTitleSx,
} from "../../app/components/tickitMarketingTheme";

export const RejectInvitation = ({ isLoading, isError, rejectInvitation }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    rejectInvitation({ invitationId: id });
  }, []);

  if (isLoading) {
    return (
      <MarketingPage>
        <Box sx={{ ...centered_flex_box, flexDirection: "column", py: 8, gap: 2 }}>
          <CircularProgress sx={{ color: marketingColors.p700 }} />
          <Typography sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray600 }}>
            Rejecting invitation...
          </Typography>
        </Box>
      </MarketingPage>
    );
  }

  return (
    <MarketingPage maxWidth="sm">
      {isError ? (
        <MarketingCard>
          <Typography sx={{ ...sectionTitleSx, fontSize: "1.5rem", textAlign: "center" }}>
            Something went wrong
          </Typography>
        </MarketingCard>
      ) : (
        <MarketingCard>
          <Typography sx={{ ...sectionTitleSx, fontSize: "1.5rem", textAlign: "center", mb: 1 }}>
            Invitation rejected
          </Typography>
          <Typography sx={{ fontFamily: marketingFonts.body, color: marketingColors.p700, textAlign: "center", fontSize: "1.25rem", mb: 3 }}>
            We are sad to see you go
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <MarketingButton onClick={() => navigate("/")}>See more events</MarketingButton>
          </Box>
        </MarketingCard>
      )}
    </MarketingPage>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state?.wait?.isLoading,
  isError: state?.wait?.isError,
});

const mapDispatchToProps = { rejectInvitation };

export default connect(mapStateToProps, mapDispatchToProps)(RejectInvitation);
